export const getSessionUrl = (
    href: string,
    sessionId: string,
    analyticsMode: boolean
): string => {
    const url = new URL(href);

    if (sessionId) {
        url.searchParams.set('sessionId', sessionId);
    } else {
        url.searchParams.delete('sessionId');
    }

    if (analyticsMode) {
        url.searchParams.set('mode', 'analytics');
    } else {
        url.searchParams.delete('mode');
    }

    return `${url.pathname}${url.search}`;
};
